import axios from 'axios';

const customAxios = axios.create({
    baseURL: '/api',
    // timeout: 10000,
    withCredentials: false
});

export default customAxios;
